var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { class: _vm.isDescricao ? "el-input-group el-input-group--append" : "" },
      [
        _c("vue-numeric", {
          staticClass: "el-input el-input__inner",
          attrs: {
            value: _vm.value,
            precision: 4,
            "thousand-separator": ".",
            "decimal-separator": ","
          },
          on: {
            input: function($event) {
              return _vm.$emit("input", $event)
            }
          }
        }),
        _vm.isDescricao
          ? _c("span", { staticClass: "color-black el-input-group__append" }, [
              _vm._v(_vm._s(_vm.descricao))
            ])
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1518e7ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1518e7ca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppNumber.vue
// module id = null
// module chunks = 